// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ApplicationInsightsService } from '../application-insights-service/application-insights.service';

@Injectable()
export class ApplicationInsightsErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: unknown): void {
    // injecting ApplicationInsightService via injector to avoid infinite loop in case
    // error is with service itself
    if (error instanceof Error) {
      try {
        const appInsights = this.injector.get<ApplicationInsightsService>(
          ApplicationInsightsService
        );

        if (appInsights) {
          appInsights.logException(error);
        }
      } catch (e) {
        super.handleError(e);
      }
    } else {
      super.handleError(error);
    }
  }
}
